import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { db, storage } from "../App";
import { TALENT_SEARCH_REQUEST_UPDATE, TALENT_SEARCH_REQUEST_UPDATE_FAILURE, TALENT_SEARCH_REQUEST_UPDATE_SUCCESS, TALENT_SEARCH_REQUESTS_FETCH, TALENT_SEARCH_REQUESTS_FETCH_FAILURE, TALENT_SEARCH_REQUESTS_FETCH_SUCCESS, TALENT_SUBMISSION_FAILURE, TALENT_SUBMISSION_REQUEST, TALENT_SUBMISSION_SUCCESS } from "./Types";
import { addDoc, collection, doc, getDocs, onSnapshot, updateDoc } from "firebase/firestore";
import { message } from "antd";

export const uploadFile = (file,extension, path, onProgress) => {
  return new Promise((resolve, reject) => {
    const uniqueName = `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
    const storageRef = ref(storage, `${path}/${uniqueName}.${extension||'mp4'}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(2);
        if (onProgress) {
          onProgress(progress);
        }
      },
      (error) => {
        reject(error);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(downloadURL);
      }
    );
  });
};


// Action to handle talent submissions
export const talentSearchSubmissions = (submissionData) => {
  return async (dispatch, getState) => {

    // Access the current state
    const state = getState();

    // Example: Access analytics data
    const translations = state.language.translations;

    dispatch({ type: TALENT_SUBMISSION_REQUEST });

    try {
      // Add the submission data to Firestore
      const docRef = await addDoc(collection(db, 'talentSubmissions'), {
        ...submissionData,
        time: Date.now(),
        status: 'new'
      });

      // On success, show a success message
      message.success(`${translations.talent.submissionSuccess}`);

      // Dispatch success with the new document ID
      dispatch({
        type: TALENT_SUBMISSION_SUCCESS,
        payload: { ...submissionData, id: docRef.id }, // Including doc ID in payload
      });
    } catch (error) {
      // Handle errors and show error message
      //   console.error('Error submitting talent:', error);
      message.error(`${translations.talent.submissionError}`);

      // Dispatch failure action
      dispatch({
        type: TALENT_SUBMISSION_FAILURE,
        payload: error.message,
      });
    }
  };
};



export const fetchTalentSearchRequests = () => {
  return (dispatch) => {
    dispatch({ type: TALENT_SEARCH_REQUESTS_FETCH });

    try {
      const unsubscribe = onSnapshot(collection(db, "talentSubmissions"), (querySnapshot) => {
        const requests = [];
        querySnapshot.forEach((doc) => {
          requests.push({ id: doc.id, ...doc.data() });
        });

        // Dispatch success with real-time data
        dispatch({
          type: TALENT_SEARCH_REQUESTS_FETCH_SUCCESS,
          payload: requests,
        });
      });

      // Return unsubscribe function so we can stop listening when needed
      return unsubscribe;
    } catch (error) {
      dispatch({
        type: TALENT_SEARCH_REQUESTS_FETCH_FAILURE,
        payload: error.message,
      });
    }
  };
};


export const updateTalentSearchRequests = (requestId, status) => {
  return async (dispatch) => {
    dispatch({ type: TALENT_SEARCH_REQUEST_UPDATE });

    try {
      // Update the status field for the given request ID
      const requestRef = doc(db, 'talentSubmissions', requestId);
      await updateDoc(requestRef, { status });

      // Dispatch success with the updated status
      dispatch({
        type: TALENT_SEARCH_REQUEST_UPDATE_SUCCESS,
        payload: { id: requestId, status },
      });

      // Show success message
      message.success('Request status updated successfully!');
    } catch (error) {
      // Handle error and dispatch failure
      dispatch({
        type: TALENT_SEARCH_REQUEST_UPDATE_FAILURE,
        payload: error.message,
      });
      message.error('Error updating request status. Please try again.');
    }
  };
};
